import {BaseView} from "../core/view"
import slick from "slick-carousel"
import { MobileUtil } from "../utils/mobile"

export default BaseView.extend({

    el: '.js-featured-products',

    minWidthForThreeProducts: 450,

    initialize: function () {
        let sliders = this.$el;

        if(this.isHOS) {
            this.minWidthForThreeProducts = 840;
        }

        Array.prototype.forEach.call(sliders, this.slickInit.bind(this));
    },

    slickInit: function(slider){

        const slickSlider = $(slider).find('.js-featured-products-slider');

        let opts = {
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            speed: 300,
            cssEase: 'linear',
            appendDots: slider.querySelector('.js-dots-wrapper'),
            prevArrow: slider.querySelector('.js-featured-products-slider--prev'),
            nextArrow: slider.querySelector('.js-featured-products-slider--next'),
            responsive: [
                {
                    breakpoint: this.minWidthForThreeProducts,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        appendDots: slickSlider,
                        slidesToShow: 767 > this.minWidthForThreeProducts ? 3 : 2
                    }
                }
            ]
        };

        slickSlider.on('init', function(event, slick){
            slick.$slider.addClass('featured-products__slider--visible');
        });

        slickSlider.slick(opts);

        setTimeout(this.refreshSlick.bind(slickSlider), 0);
    },

    refreshSlick: function () {
        this.slick('refresh');
    }
});